export const CSItems = [
  {
    name: "COMP189 - Computers and Society",
  },
  {
    name: "COMP202 - Fundamentals of Programming",
  },
  {
    name: "COMP206 - Introduction to Software Systems",
  },
  {
    name: "COMP250 - Introduction to Computer Science",
  },
  {
    name: "COMP252 - Honours Algorithms and Data Structures",
  },
  {
    name: "COMP273 - Introduction to Computer Systems",
  },
  {
    name: "COMP302 - Programming Languages and Paradigms",
  },
  {
    name: "COMP303 - Software Design",
  },
  {
    name: "COMP310 - Operating Systems",
  },
  {
    name: "COMP321 - Programming Challenges",
  },
  {
    name: "COMP322 - Introduction to C++",
  },
  {
    name: "COMOP330 - Theory of Computation",
  },
  {
    name: "Algorithm Design",
  },
  {
    name: "COMP400 - Project in Computer Science",
  },
  {
    name: "COMP421 - Database Systems",
  },
  {
    name: "COMP520 - Compiler Design",
  },
  {
    name: "COMP551 - Applied Machine Learning",
  },
  {
    name: "COMP598 - Intro to Data Science",
  },
];

export const MathItems = [
  {
    name: "MATH133 - Linear Algebra 1",
  },
  {
    name: "MATH140 - Calculus 1",
  },
  {
    name: "MATH141 - Calculus 2",
  },
  {
    name: "MATH208 - Intro to Statistical Computing",
  },
  {
    name: "MATH222 - Calculus 3",
  },
  {
    name: "MATH223 - Linear Algebra 2",
  },
  {
    name: "MATH240 - Discrete Structures 1",
  },
  {
    name: "MATH308 - Fundamentals of Statistical Learning",
  },
  {
    name: "MATH323 - Probability",
  },
  {
    name: "MATH324 - Statistics",
  },
  {
    name: "MATH340 - Discrete Structures 2",
  },
];
